import { useState } from 'react';
import { Button } from '../../button/button';
import { Input } from '../../input';

const SUGGESTED_LIMIT_DOLLARS = '5';

/** Lets the customer lift the spend limit themselves and carry on. */
export function RaiseSpendLimit({
  onRaise,
}: {
  onRaise: (budgetCents: number) => Promise<void>;
}) {
  const [dollars, setDollars] = useState(SUGGESTED_LIMIT_DOLLARS);
  const [isRaising, setIsRaising] = useState(false);
  const cents = Math.round(Number(dollars) * 100);
  const isValid = Number.isFinite(cents) && cents >= 1 && cents <= 100_000;

  return (
    <form
      className="flex flex-wrap items-center gap-2 pl-6"
      onSubmit={async (event) => {
        event.preventDefault();
        setIsRaising(true);
        await onRaise(cents);
        setIsRaising(false);
      }}
    >
      <label htmlFor="raise-spend-limit" className="text-sm">
        New limit per simulation $
      </label>
      <Input
        id="raise-spend-limit"
        type="number"
        min="0.01"
        max="1000"
        step="0.01"
        value={dollars}
        onChange={(event) => setDollars(event.target.value)}
        className="h-8 w-24 bg-prompt-safecomwhite tabular-nums text-prompt-safecomvulcan"
      />
      <Button
        type="submit"
        size="sm"
        disabled={!isValid || isRaising}
        className="bg-red-700 text-white hover:bg-red-800"
      >
        {isRaising ? 'Raising…' : 'Raise limit and continue'}
      </Button>
    </form>
  );
}
